import { useParams } from '@tanstack/react-router'
import { useSearch } from '@tanstack/react-router'
import { generateId } from 'ai'
import { useEffect, useState } from 'react'
import ChatPreviewInteractive from '@/features/ai-hub/assistant/components/chat-preview/ChatPreviewInteractive'
import { AssistantEditProvider, useAssistantEdit } from '@/features/ai-hub/assistant/context/assistant-edit-context'
import { useDeployedVersionQuery } from '@/features/ai-hub/assistant/hooks/use-assistant-query'
import '@/index.css'

const EmbedAssistantContent = () => {
  const { assistantId } = useParams({
    from: '/embed/assistant/$assistantId',
  })
  
  const search = useSearch({
    from: '/embed/assistant/$assistantId',
  }) as {
    height?: string
    width?: string
    conversationId?: string
  }
  
  const { data: deployedVersionResponse } = useDeployedVersionQuery(assistantId)
  const { setOriginalAssistant } = useAssistantEdit()
  
  const [conversationId, setConversationId] = useState(() => 
    search.conversationId || generateId()
  )
  
  useEffect(() => {
    if (deployedVersionResponse?.version) {
      setOriginalAssistant(deployedVersionResponse.version)
    }
  }, [deployedVersionResponse, setOriginalAssistant])
  
  const handleNewConversation = () => {
    setConversationId(generateId())
  }
  
  const height = search.height || '100%'
  const width = search.width || '100%'

  return (
    <div 
      className="w-full h-full bg-transparent" 
      style={{ 
        height: height === '100%' ? '100vh' : height,
        width,
        minHeight: '400px'
      }}
    >
      <ChatPreviewInteractive
        key={conversationId}
        conversationId={conversationId}
        onReset={handleNewConversation}
        isEmbed={true}
      />
    </div>
  )
}

export const EmbedAssistantPage = () => {
  return (
    <AssistantEditProvider>
      <EmbedAssistantContent />
    </AssistantEditProvider>
  )
}